var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"already-container"},[_c('p',[_vm._v("您绑定的passport账号是："+_vm._s(_vm.Phone))])])}
var staticRenderFns = []

export { render, staticRenderFns }